import { Paper, Stack, Typography, Grid, TextField, Box } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutlined'
import AnDateField from '../../../../components/DateTime/DateField'

const PatientDetailsCard = ({
  patientName,
  setPatientName,
  patientDOB,
  setPatientDOB,
  prfNumber,
  setPrfNumber,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <PersonOutlineIcon color="primary" />
          <Box>
            <Typography variant="h6" fontWeight={800}>
              Patient Details
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Link this administration to the patient or PRF where available.
            </Typography>
          </Box>
        </Stack>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              value={patientName}
              onChange={(e) => setPatientName(e.target.value)}
              label="Patient Name"
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <AnDateField
              value={patientDOB}
              onChange={(newDate) => setPatientDOB(newDate)}
              label="Patient DOB"
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="PRF Number"
              fullWidth
              value={prfNumber}
              onChange={(e) => setPrfNumber(e.target.value)}
              placeholder="Optional paper PRF / record number"
            />
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  )
}

export default PatientDetailsCard
